export const REGION = 'eu-west-1';
export const IMAGE_PLACEHOLDER = '/images/icons/icon-no-image.png';
export const UNIT_METRICS = 'metrics';
export const UNIT_IMPERIAL = 'imperial';
export const LOCAL_STORAGE = {
    UNIT_MEASUREMENT: 'unitMeasurement',
};
export const VIDEO_EXTENSIONS = ['mp4', 'mkv', '3gp', 'webm', 'avi', 'mov', 'mts', 'm2ts', 'mxf'];
export const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'heif', 'heic', 'webp', 'tiff', 'raw', 'bmp', 'indd'];
export const getFileType = (name, privateBucket) => {
    const ext = (name === null || name === void 0 ? void 0 : name.split('.').pop()) || '';
    const isVideo = VIDEO_EXTENSIONS.includes(ext.toLowerCase());
    if (isVideo) {
        return {
            id: name,
            file_name: `original/${name}`,
            file_type: `video${privateBucket ? '-document' : ''}`,
            preview_image: `${name}`.replace(`.${ext}`, '.jpg'),
        };
    }
    const isImage = IMAGE_EXTENSIONS.includes(ext.toLowerCase());
    if (isImage) {
        return {
            id: name,
            file_name: `original/${name}`,
            file_type: `image${privateBucket ? '-document' : ''}`,
            preview_image: name,
        };
    }
    return {
        id: name,
        file_name: `original/${name}`,
        file_type: `embed${privateBucket ? '-document' : ''}`,
        preview_image: `${name}`.replace(`.${ext}`, '.png'),
    };
};
